import _asyncToGenerator from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/home/runner/work/website/website/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n2 = 0, F = function F() {}; return { s: F, n: function n() { return _n2 >= r.length ? { done: !0 } : { done: !1, value: r[_n2++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/esnext.global-this.js";
var ir = Object.defineProperty;
var sr = function sr(t, n, i) {
  return n in t ? ir(t, n, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: i
  }) : t[n] = i;
};
var g = function g(t, n, i) {
  return sr(t, typeof n != "symbol" ? n + "" : n, i);
};
var Tt = {
    0: 8203,
    1: 8204,
    2: 8205,
    3: 8290,
    4: 8291,
    5: 8288,
    6: 65279,
    7: 8289,
    8: 119155,
    9: 119156,
    a: 119157,
    b: 119158,
    c: 119159,
    d: 119160,
    e: 119161,
    f: 119162
  },
  ze = {
    0: 8203,
    1: 8204,
    2: 8205,
    3: 65279
  },
  _t = new Array(4).fill(String.fromCodePoint(ze[0])).join(""),
  pt = "\0";
function ar(t) {
  var n = JSON.stringify(t);
  return "".concat(_t).concat(Array.from(n).map(function (i) {
    var a = i.charCodeAt(0);
    if (a > 255) throw new Error("Only ASCII edit info can be encoded. Error attempting to encode ".concat(n, " on character ").concat(i, " (").concat(a, ")"));
    return Array.from(a.toString(4).padStart(4, "0")).map(function (s) {
      return String.fromCodePoint(ze[s]);
    }).join("");
  }).join(""));
}
function or(t) {
  return !Number.isNaN(Number(t)) || /[a-z]/i.test(t) && !/\d+(?:[-:\/]\d+){2}(?:T\d+(?:[-:\/]\d+){1,2}(\.\d+)?Z?)?/.test(t) ? !1 : !!Date.parse(t);
}
function cr(t) {
  try {
    new URL(t, t.startsWith("/") ? "https://acme.com" : void 0);
  } catch (_unused) {
    return !1;
  }
  return !0;
}
function lr(t, n) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "auto";
  return i === !0 || i === "auto" && (or(t) || cr(t)) ? t : "".concat(t).concat(ar(n));
}
var ur = Object.fromEntries(Object.entries(ze).map(function (t) {
    return t.reverse();
  })),
  gt = Object.fromEntries(Object.entries(Tt).map(function (t) {
    return t.reverse();
  })),
  fr = "".concat(Object.values(Tt).map(function (t) {
    return "\\u{".concat(t.toString(16), "}");
  }).join("")),
  je = new RegExp("[".concat(fr, "]{4,}"), "gu");
function dr(t) {
  var n = t.match(je);
  if (n) return pr(n[0], !0)[0];
}
function pr(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  var i = Array.from(t);
  if (i.length % 2 === 0) {
    if (i.length % 4 || !t.startsWith(_t)) return gr(i, n);
  } else throw new Error("Encoded data has invalid length");
  var a = [];
  for (var s = i.length * 0.25; s--;) {
    var c = i.slice(s * 4, s * 4 + 4).map(function (u) {
      return ur[u.codePointAt(0)];
    }).join("");
    a.unshift(String.fromCharCode(parseInt(c, 4)));
  }
  if (n) {
    a.shift();
    var _s = a.indexOf(pt);
    return _s === -1 && (_s = a.length), [JSON.parse(a.slice(0, _s).join(""))];
  }
  return a.join("").split(pt).filter(Boolean).map(function (s) {
    return JSON.parse(s);
  });
}
function gr(t, n) {
  var i;
  var a = [];
  for (var d = t.length * 0.5; d--;) {
    var E = "".concat(gt[t[d * 2].codePointAt(0)]).concat(gt[t[d * 2 + 1].codePointAt(0)]);
    a.unshift(String.fromCharCode(parseInt(E, 16)));
  }
  var s = [],
    c = [a.join("")],
    u = 10;
  for (; c.length;) {
    var _d = c.shift();
    try {
      if (s.push(JSON.parse(_d)), n) return s;
    } catch (E) {
      if (!u--) throw E;
      var f = +((i = E.message.match(/\sposition\s(\d+)$/)) == null ? void 0 : i[1]);
      if (!f) throw E;
      c.unshift(_d.substring(0, f), _d.substring(f));
    }
  }
  return s;
}
function hr(t) {
  var n;
  return {
    cleaned: t.replace(je, ""),
    encoded: ((n = t.match(je)) == null ? void 0 : n[0]) || ""
  };
}
function $e(t, n) {
  return lr(t, n);
}
function vt(t) {
  return dr(t);
}
function Qr(t) {
  return hr(t);
}
var Er = Object.prototype.hasOwnProperty,
  yr = Object.prototype.toString,
  mr = function mr(t, n, i) {
    if (yr.call(n) !== "[object Function]") throw new TypeError("iterator must be a function");
    var a = t.length;
    if (a === +a) for (var s = 0; s < a; s++) n.call(i, t[s], s, t);else for (var c in t) Er.call(t, c) && n.call(i, t[c], c, t);
  },
  br = mr,
  K = b;
function b(t, n, i) {
  if (arguments.length === 3) return b.set(t, n, i);
  if (arguments.length === 2) return b.get(t, n);
  var a = b.bind(b, t);
  for (var s in b) b.hasOwnProperty(s) && (a[s] = b[s].bind(a, t));
  return a;
}
b.get = function (t, n) {
  for (var i = Array.isArray(n) ? n : b.parse(n), a = 0; a < i.length; ++a) {
    var s = i[a];
    if (!(typeof t == "object" && s in t)) throw new Error("Invalid reference token: " + s);
    t = t[s];
  }
  return t;
};
b.set = function (t, n, i) {
  var a = Array.isArray(n) ? n : b.parse(n),
    s = a[0];
  if (a.length === 0) throw Error("Can not set the root object");
  for (var c = 0; c < a.length - 1; ++c) {
    var u = a[c];
    typeof u != "string" && typeof u != "number" && (u = String(u)), !(u === "__proto__" || u === "constructor" || u === "prototype") && (u === "-" && Array.isArray(t) && (u = t.length), s = a[c + 1], u in t || (s.match(/^(\d+|-)$/) ? t[u] = [] : t[u] = {}), t = t[u]);
  }
  return s === "-" && Array.isArray(t) && (s = t.length), t[s] = i, this;
};
b.remove = function (t, n) {
  var i = Array.isArray(n) ? n : b.parse(n),
    a = i[i.length - 1];
  if (a === void 0) throw new Error('Invalid JSON pointer for remove: "' + n + '"');
  var s = b.get(t, i.slice(0, -1));
  if (Array.isArray(s)) {
    var c = +a;
    if (a === "" && isNaN(c)) throw new Error('Invalid array index: "' + a + '"');
    Array.prototype.splice.call(s, c, 1);
  } else delete s[a];
};
b.dict = function (t, n) {
  var i = {};
  return b.walk(t, function (a, s) {
    i[s] = a;
  }, n), i;
};
b.walk = function (t, n, i) {
  var a = [];
  i = i || function (s) {
    var c = Object.prototype.toString.call(s);
    return c === "[object Object]" || c === "[object Array]";
  }, function s(c) {
    br(c, function (u, d) {
      a.push(String(d)), i(u) ? s(u) : n(u, b.compile(a)), a.pop();
    });
  }(t);
};
b.has = function (t, n) {
  try {
    b.get(t, n);
  } catch (_unused2) {
    return !1;
  }
  return !0;
};
b.escape = function (t) {
  return t.toString().replace(/~/g, "~0").replace(/\//g, "~1");
};
b.unescape = function (t) {
  return t.replace(/~1/g, "/").replace(/~0/g, "~");
};
b.parse = function (t) {
  if (t === "") return [];
  if (t.charAt(0) !== "/") throw new Error("Invalid JSON pointer: " + t);
  return t.substring(1).split(/\//).map(b.unescape);
};
b.compile = function (t) {
  return t.length === 0 ? "" : "/" + t.map(b.escape).join("/");
};
var Tr = function Tr(_ref) {
    var t = _ref.pointer,
      n = _ref.mappings,
      i = _ref.data,
      a = _ref.hiddenStrings;
    var s = n[t];
    delete n[t];
    var c = St(i, t);
    var _iterator = _createForOfIteratorHelper(c),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var u = _step.value;
        n[u] = s;
        var d = K.get(i, u),
          E = $e(d, a);
        K.set(i, u, E);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  St = function St(t) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var i = [],
      a = K.get(t, n);
    if (a.content) for (var s = 0; s < a.content.length; s++) a.content[s].nodeType === "text" ? i.push("".concat(n, "/content/").concat(s, "/value")) : i.push.apply(i, _toConsumableArray(St(t, "".concat(n, "/content/").concat(s))));
    return i;
  },
  Ge = function Ge(_ref2) {
    var t = _ref2.entityId,
      n = _ref2.entityType,
      i = _ref2.space,
      a = _ref2.environment,
      s = _ref2.field,
      c = _ref2.locale,
      u = _ref2.editorInterface,
      d = _ref2.fieldType,
      E = _ref2.targetOrigin,
      f = _ref2.platform;
    var h = {
      origin: "contentful.com",
      href: "".concat("".concat(E || "https://app.contentful.com", "/spaces/").concat(i, "/environments/").concat(a), "/", n === "Entry" ? "entries" : "assets", "/").concat(t, "/?focusedField=").concat(s, "&focusedLocale=").concat(c),
      contentful: {
        space: i,
        environment: a,
        field: s,
        locale: c,
        entity: t,
        entityType: n,
        editorInterface: u,
        fieldType: d
      }
    };
    return f === "vercel" && delete h.contentful, f === "contentful" && delete h.href, h;
  },
  It = function It(t) {
    return ["builtin", "sidebar-builtin", "editor-builtin"].includes(t);
  },
  At = function At(t) {
    return _r.includes(t);
  };
function Ot(t) {
  if (typeof structuredClone == "function") return structuredClone(t);
  try {
    return JSON.parse(JSON.stringify(t));
  } catch (n) {
    return console.warn("Failed to clone data:", t, n), t;
  }
}
var _r = ["singleLine", "tagEditor", "listInput", "checkbox", "richTextEditor", "multipleLine", "markdown"];
function Be(t, n, i, a, s, c, u) {
  var d = u ? n[u] : n;
  switch (t) {
    case "Symbol":
      {
        var E = $e(d, i);
        K.set(a, s, E);
        break;
      }
    case "RichText":
      {
        Tr({
          pointer: "",
          mappings: c,
          data: d,
          hiddenStrings: i
        });
        break;
      }
    case "Array":
      {
        var _E = d.map(function (f) {
          return typeof f == "string" ? $e(f, i) : f;
        });
        K.set(a, s, _E);
        break;
      }
  }
}
var Xr = function Xr(t, n, i) {
    if (!t || !t.extensions || !t.extensions.contentSourceMaps) return console.error("GraphQL response does not contain Content Source Maps information.", t), t;
    var a = Ot(t),
      _a$extensions$content = a.extensions.contentSourceMaps,
      s = _a$extensions$content.spaces,
      c = _a$extensions$content.environments,
      u = _a$extensions$content.editorInterfaces,
      d = _a$extensions$content.fields,
      E = _a$extensions$content.locales,
      f = _a$extensions$content.entries,
      h = _a$extensions$content.assets,
      y = _a$extensions$content.mappings,
      A = _a$extensions$content.fieldTypes,
      O = a;
    for (var C in y) {
      var v = y[C].source,
        L = "entry" in v ? f[v.entry] : h[v.asset],
        G = "entry" in v ? "Entry" : "Asset";
      if (!L) return a;
      var j = s[L.space],
        B = c[L.environment],
        ae = L.id,
        de = d[v.field],
        re = E[v.locale],
        ie = u[v.editorInterface],
        pe = A[v.fieldType];
      if (!(It(ie.widgetNamespace) && !At(ie.widgetId))) if (K.has(O, C)) {
        var ge = K.get(O, C);
        if (ge !== null) {
          var oe = Ge({
            entityId: ae,
            entityType: G,
            space: j,
            environment: B,
            field: de,
            locale: re,
            editorInterface: ie,
            fieldType: pe,
            targetOrigin: n,
            platform: i
          });
          Be(pe, ge, oe, O, C, y);
        }
      } else console.error("Pointer ".concat(C, " not found in GraphQL data or href could not be generated."));
    }
    return a;
  },
  Ie = function Ie(t, n, i, a, s) {
    if (!t.fields) return;
    var c = t.sys.contentSourceMaps;
    if (!c) {
      console.error("Content source maps data is missing");
      return;
    }
    var u = c.mappings;
    var _loop = function _loop() {
        var E = u[d].source,
          f = t.sys.space.sys.id,
          h = t.sys.environment.sys.id,
          y = t.sys.id,
          A = t.sys.type,
          O = n[E.fieldType],
          C = i[E.editorInterface];
        if (It(C.widgetNamespace) && !At(C.widgetId)) return 0; // continue
        var v = d.startsWith("/") ? d : "/".concat(d);
        if (K.has(t, v)) {
          var L = K.get(t, v);
          if (L === null) return {
            v: void 0
          };
          var G = v.split("/").pop();
          if (!G) {
            console.error("Field name could not be extracted from the pointer", v);
            return {
              v: void 0
            };
          }
          var j = t.sys.locale;
          if (j) {
            var B = Ge({
              entityId: y,
              entityType: A,
              space: f,
              environment: h,
              field: G,
              locale: j,
              editorInterface: C,
              fieldType: O,
              targetOrigin: a,
              platform: s
            });
            Be(O, L, B, t, v, u);
          } else Object.keys(L).forEach(function (B) {
            var ae = Ge({
              entityId: y,
              entityType: A,
              space: f,
              environment: h,
              field: G,
              locale: B,
              editorInterface: C,
              fieldType: O,
              targetOrigin: a,
              platform: s
            });
            Be(O, L, ae, t, "".concat(v, "/").concat(B), u, B);
          });
        } else console.error("Pointer not found in the target", d, t);
      },
      _ret;
    for (var d in u) {
      _ret = _loop();
      if (_ret === 0) continue;
      if (_ret) return _ret.v;
    }
  },
  kr = function kr(t, n, i) {
    var a;
    var s = Ot(t);
    if (s.sys && "items" in s) {
      var c = s;
      if (!((a = c.sys) != null && a.contentSourceMapsLookup)) return console.error("Content source maps lookup data is missing"), c;
      var _c$sys$contentSourceM = c.sys.contentSourceMapsLookup,
        u = _c$sys$contentSourceM.fieldTypes,
        d = _c$sys$contentSourceM.editorInterfaces,
        E = c.items,
        f = c.includes;
      E.forEach(function (h) {
        return Ie(h, u, d, n, i);
      }), f && f.Entry && f.Entry.forEach(function (h) {
        return Ie(h, u, d, n, i);
      }), f && f.Asset && f.Asset.forEach(function (h) {
        return Ie(h, u, d, n, i);
      });
    } else {
      var _c = s;
      if (!_c.sys.contentSourceMapsLookup) return console.error("Content source maps lookup data is missing"), _c;
      Ie(_c, _c.sys.contentSourceMapsLookup.fieldTypes, _c.sys.contentSourceMapsLookup.editorInterfaces, n, i);
    }
    return s;
  },
  Ct = "4.3.0";
var wt = !1;
function ht(t) {
  wt = t;
}
var xe = function xe(t) {
    return function () {
      var _console;
      wt && (_console = console)[t].apply(_console, arguments);
    };
  },
  W = {
    error: xe("error"),
    warn: xe("warn"),
    log: xe("log")
  };
function vr(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var i = window.location.href;
  var s = setInterval(function () {
    var c = window.location.href;
    c !== i && (i = c, t(c));
  }, n);
  return function () {
    return clearInterval(s);
  };
}
var Sr = "live-preview-editor",
  Ir = "live-preview-sdk";
function F(t, n, i) {
  var a = _objectSpread(_objectSpread({}, n), {}, {
    method: t,
    source: Ir,
    location: window.location.href,
    version: Ct
  });
  W.log("Send message", a), i.forEach(function (s) {
    var c;
    (c = window.top) == null || c.postMessage(a, s);
  });
}
function Ar(t) {
  var _this = this;
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var i;
  return function () {
    for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
      a[_key] = arguments[_key];
    }
    clearTimeout(i), i = setTimeout(function () {
      t.apply(_this, a);
    }, n);
  };
}
function Or() {
  var t;
  try {
    return ((t = window.top) == null ? void 0 : t.location.href) !== window.location.href;
  } catch (_unused3) {
    return !0;
  }
}
function Cr() {
  return "".concat(performance.now(), "-").concat(Math.random().toString(36).slice(2));
}
function wr(t) {
  return typeof t.data != "object" || !t.data ? !1 : "source" in t.data && t.data.source === Sr;
}
var Ae = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Dr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Oe = {
  exports: {}
};
Oe.exports;
(function (t, n) {
  var i = 200,
    a = "__lodash_hash_undefined__",
    s = 1,
    c = 2,
    u = 9007199254740991,
    d = "[object Arguments]",
    E = "[object Array]",
    f = "[object AsyncFunction]",
    h = "[object Boolean]",
    y = "[object Date]",
    A = "[object Error]",
    O = "[object Function]",
    C = "[object GeneratorFunction]",
    v = "[object Map]",
    L = "[object Number]",
    G = "[object Null]",
    j = "[object Object]",
    B = "[object Promise]",
    ae = "[object Proxy]",
    de = "[object RegExp]",
    re = "[object Set]",
    ie = "[object String]",
    pe = "[object Symbol]",
    ge = "[object Undefined]",
    oe = "[object WeakMap]",
    Pe = "[object ArrayBuffer]",
    he = "[object DataView]",
    Mt = "[object Float32Array]",
    xt = "[object Float64Array]",
    jt = "[object Int8Array]",
    $t = "[object Int16Array]",
    Gt = "[object Int32Array]",
    Bt = "[object Uint8Array]",
    zt = "[object Uint8ClampedArray]",
    Ft = "[object Uint16Array]",
    Pt = "[object Uint32Array]",
    Ht = /[\\^$.*+?()[\]{}|]/g,
    Vt = /^\[object .+?Constructor\]$/,
    Yt = /^(?:0|[1-9]\d*)$/,
    T = {};
  T[Mt] = T[xt] = T[jt] = T[$t] = T[Gt] = T[Bt] = T[zt] = T[Ft] = T[Pt] = !0, T[d] = T[E] = T[Pe] = T[h] = T[he] = T[y] = T[A] = T[O] = T[v] = T[L] = T[j] = T[de] = T[re] = T[ie] = T[oe] = !1;
  var He = typeof Ae == "object" && Ae && Ae.Object === Object && Ae,
    Kt = typeof self == "object" && self && self.Object === Object && self,
    H = He || Kt || Function("return this")(),
    Ve = n && !n.nodeType && n,
    Ye = Ve && !0 && t && !t.nodeType && t,
    Ke = Ye && Ye.exports === Ve,
    Ce = Ke && He.process,
    Je = function () {
      try {
        return Ce && Ce.binding && Ce.binding("util");
      } catch (_unused4) {}
    }(),
    qe = Je && Je.isTypedArray;
  function Jt(e, r) {
    for (var o = -1, l = e == null ? 0 : e.length, _ = 0, p = []; ++o < l;) {
      var I = e[o];
      r(I, o, e) && (p[_++] = I);
    }
    return p;
  }
  function qt(e, r) {
    for (var o = -1, l = r.length, _ = e.length; ++o < l;) e[_ + o] = r[o];
    return e;
  }
  function Zt(e, r) {
    for (var o = -1, l = e == null ? 0 : e.length; ++o < l;) if (r(e[o], o, e)) return !0;
    return !1;
  }
  function Wt(e, r) {
    for (var o = -1, l = Array(e); ++o < e;) l[o] = r(o);
    return l;
  }
  function Qt(e) {
    return function (r) {
      return e(r);
    };
  }
  function Xt(e, r) {
    return e.has(r);
  }
  function kt(e, r) {
    return e == null ? void 0 : e[r];
  }
  function en(e) {
    var r = -1,
      o = Array(e.size);
    return e.forEach(function (l, _) {
      o[++r] = [_, l];
    }), o;
  }
  function tn(e, r) {
    return function (o) {
      return e(r(o));
    };
  }
  function nn(e) {
    var r = -1,
      o = Array(e.size);
    return e.forEach(function (l) {
      o[++r] = l;
    }), o;
  }
  var rn = Array.prototype,
    sn = Function.prototype,
    Ee = Object.prototype,
    we = H["__core-js_shared__"],
    Ze = sn.toString,
    z = Ee.hasOwnProperty,
    We = function () {
      var e = /[^.]+$/.exec(we && we.keys && we.keys.IE_PROTO || "");
      return e ? "Symbol(src)_1." + e : "";
    }(),
    Qe = Ee.toString,
    an = RegExp("^" + Ze.call(z).replace(Ht, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
    Xe = Ke ? H.Buffer : void 0,
    ye = H.Symbol,
    ke = H.Uint8Array,
    et = Ee.propertyIsEnumerable,
    on = rn.splice,
    Q = ye ? ye.toStringTag : void 0,
    tt = Object.getOwnPropertySymbols,
    cn = Xe ? Xe.isBuffer : void 0,
    ln = tn(Object.keys, Object),
    De = se(H, "DataView"),
    ce = se(H, "Map"),
    Ne = se(H, "Promise"),
    Le = se(H, "Set"),
    Re = se(H, "WeakMap"),
    le = se(Object, "create"),
    un = ee(De),
    fn = ee(ce),
    dn = ee(Ne),
    pn = ee(Le),
    gn = ee(Re),
    nt = ye ? ye.prototype : void 0,
    Ue = nt ? nt.valueOf : void 0;
  function X(e) {
    var r = -1,
      o = e == null ? 0 : e.length;
    for (this.clear(); ++r < o;) {
      var l = e[r];
      this.set(l[0], l[1]);
    }
  }
  function hn() {
    this.__data__ = le ? le(null) : {}, this.size = 0;
  }
  function En(e) {
    var r = this.has(e) && delete this.__data__[e];
    return this.size -= r ? 1 : 0, r;
  }
  function yn(e) {
    var r = this.__data__;
    if (le) {
      var o = r[e];
      return o === a ? void 0 : o;
    }
    return z.call(r, e) ? r[e] : void 0;
  }
  function mn(e) {
    var r = this.__data__;
    return le ? r[e] !== void 0 : z.call(r, e);
  }
  function bn(e, r) {
    var o = this.__data__;
    return this.size += this.has(e) ? 0 : 1, o[e] = le && r === void 0 ? a : r, this;
  }
  X.prototype.clear = hn, X.prototype.delete = En, X.prototype.get = yn, X.prototype.has = mn, X.prototype.set = bn;
  function V(e) {
    var r = -1,
      o = e == null ? 0 : e.length;
    for (this.clear(); ++r < o;) {
      var l = e[r];
      this.set(l[0], l[1]);
    }
  }
  function Tn() {
    this.__data__ = [], this.size = 0;
  }
  function _n(e) {
    var r = this.__data__,
      o = be(r, e);
    if (o < 0) return !1;
    var l = r.length - 1;
    return o == l ? r.pop() : on.call(r, o, 1), --this.size, !0;
  }
  function vn(e) {
    var r = this.__data__,
      o = be(r, e);
    return o < 0 ? void 0 : r[o][1];
  }
  function Sn(e) {
    return be(this.__data__, e) > -1;
  }
  function In(e, r) {
    var o = this.__data__,
      l = be(o, e);
    return l < 0 ? (++this.size, o.push([e, r])) : o[l][1] = r, this;
  }
  V.prototype.clear = Tn, V.prototype.delete = _n, V.prototype.get = vn, V.prototype.has = Sn, V.prototype.set = In;
  function k(e) {
    var r = -1,
      o = e == null ? 0 : e.length;
    for (this.clear(); ++r < o;) {
      var l = e[r];
      this.set(l[0], l[1]);
    }
  }
  function An() {
    this.size = 0, this.__data__ = {
      hash: new X(),
      map: new (ce || V)(),
      string: new X()
    };
  }
  function On(e) {
    var r = Te(this, e).delete(e);
    return this.size -= r ? 1 : 0, r;
  }
  function Cn(e) {
    return Te(this, e).get(e);
  }
  function wn(e) {
    return Te(this, e).has(e);
  }
  function Dn(e, r) {
    var o = Te(this, e),
      l = o.size;
    return o.set(e, r), this.size += o.size == l ? 0 : 1, this;
  }
  k.prototype.clear = An, k.prototype.delete = On, k.prototype.get = Cn, k.prototype.has = wn, k.prototype.set = Dn;
  function me(e) {
    var r = -1,
      o = e == null ? 0 : e.length;
    for (this.__data__ = new k(); ++r < o;) this.add(e[r]);
  }
  function Nn(e) {
    return this.__data__.set(e, a), this;
  }
  function Ln(e) {
    return this.__data__.has(e);
  }
  me.prototype.add = me.prototype.push = Nn, me.prototype.has = Ln;
  function J(e) {
    var r = this.__data__ = new V(e);
    this.size = r.size;
  }
  function Rn() {
    this.__data__ = new V(), this.size = 0;
  }
  function Un(e) {
    var r = this.__data__,
      o = r.delete(e);
    return this.size = r.size, o;
  }
  function Mn(e) {
    return this.__data__.get(e);
  }
  function xn(e) {
    return this.__data__.has(e);
  }
  function jn(e, r) {
    var o = this.__data__;
    if (o instanceof V) {
      var l = o.__data__;
      if (!ce || l.length < i - 1) return l.push([e, r]), this.size = ++o.size, this;
      o = this.__data__ = new k(l);
    }
    return o.set(e, r), this.size = o.size, this;
  }
  J.prototype.clear = Rn, J.prototype.delete = Un, J.prototype.get = Mn, J.prototype.has = xn, J.prototype.set = jn;
  function $n(e, r) {
    var o = _e(e),
      l = !o && Xn(e),
      _ = !o && !l && Me(e),
      p = !o && !l && !_ && ft(e),
      I = o || l || _ || p,
      w = I ? Wt(e.length, String) : [],
      D = w.length;
    for (var S in e) (r || z.call(e, S)) && !(I && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    S == "length" ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    _ && (S == "offset" || S == "parent") ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    p && (S == "buffer" || S == "byteLength" || S == "byteOffset") ||
    // Skip index properties.
    Jn(S, D))) && w.push(S);
    return w;
  }
  function be(e, r) {
    for (var o = e.length; o--;) if (ot(e[o][0], r)) return o;
    return -1;
  }
  function Gn(e, r, o) {
    var l = r(e);
    return _e(e) ? l : qt(l, o(e));
  }
  function ue(e) {
    return e == null ? e === void 0 ? ge : G : Q && Q in Object(e) ? Yn(e) : Qn(e);
  }
  function rt(e) {
    return fe(e) && ue(e) == d;
  }
  function it(e, r, o, l, _) {
    return e === r ? !0 : e == null || r == null || !fe(e) && !fe(r) ? e !== e && r !== r : Bn(e, r, o, l, it, _);
  }
  function Bn(e, r, o, l, _, p) {
    var I = _e(e),
      w = _e(r),
      D = I ? E : q(e),
      S = w ? E : q(r);
    D = D == d ? j : D, S = S == d ? j : S;
    var U = D == j,
      $ = S == j,
      N = D == S;
    if (N && Me(e)) {
      if (!Me(r)) return !1;
      I = !0, U = !1;
    }
    if (N && !U) return p || (p = new J()), I || ft(e) ? st(e, r, o, l, _, p) : Hn(e, r, D, o, l, _, p);
    if (!(o & s)) {
      var M = U && z.call(e, "__wrapped__"),
        x = $ && z.call(r, "__wrapped__");
      if (M || x) {
        var Z = M ? e.value() : e,
          Y = x ? r.value() : r;
        return p || (p = new J()), _(Z, Y, o, l, p);
      }
    }
    return N ? (p || (p = new J()), Vn(e, r, o, l, _, p)) : !1;
  }
  function zn(e) {
    if (!ut(e) || Zn(e)) return !1;
    var r = ct(e) ? an : Vt;
    return r.test(ee(e));
  }
  function Fn(e) {
    return fe(e) && lt(e.length) && !!T[ue(e)];
  }
  function Pn(e) {
    if (!Wn(e)) return ln(e);
    var r = [];
    for (var o in Object(e)) z.call(e, o) && o != "constructor" && r.push(o);
    return r;
  }
  function st(e, r, o, l, _, p) {
    var I = o & s,
      w = e.length,
      D = r.length;
    if (w != D && !(I && D > w)) return !1;
    var S = p.get(e);
    if (S && p.get(r)) return S == r;
    var U = -1,
      $ = !0,
      N = o & c ? new me() : void 0;
    for (p.set(e, r), p.set(r, e); ++U < w;) {
      var M = e[U],
        x = r[U];
      if (l) var Z = I ? l(x, M, U, r, e, p) : l(M, x, U, e, r, p);
      if (Z !== void 0) {
        if (Z) continue;
        $ = !1;
        break;
      }
      if (N) {
        if (!Zt(r, function (Y, te) {
          if (!Xt(N, te) && (M === Y || _(M, Y, o, l, p))) return N.push(te);
        })) {
          $ = !1;
          break;
        }
      } else if (!(M === x || _(M, x, o, l, p))) {
        $ = !1;
        break;
      }
    }
    return p.delete(e), p.delete(r), $;
  }
  function Hn(e, r, o, l, _, p, I) {
    switch (o) {
      case he:
        if (e.byteLength != r.byteLength || e.byteOffset != r.byteOffset) return !1;
        e = e.buffer, r = r.buffer;
      case Pe:
        return !(e.byteLength != r.byteLength || !p(new ke(e), new ke(r)));
      case h:
      case y:
      case L:
        return ot(+e, +r);
      case A:
        return e.name == r.name && e.message == r.message;
      case de:
      case ie:
        return e == r + "";
      case v:
        var w = en;
      case re:
        var D = l & s;
        if (w || (w = nn), e.size != r.size && !D) return !1;
        var S = I.get(e);
        if (S) return S == r;
        l |= c, I.set(e, r);
        var U = st(w(e), w(r), l, _, p, I);
        return I.delete(e), U;
      case pe:
        if (Ue) return Ue.call(e) == Ue.call(r);
    }
    return !1;
  }
  function Vn(e, r, o, l, _, p) {
    var I = o & s,
      w = at(e),
      D = w.length,
      S = at(r),
      U = S.length;
    if (D != U && !I) return !1;
    for (var $ = D; $--;) {
      var N = w[$];
      if (!(I ? N in r : z.call(r, N))) return !1;
    }
    var M = p.get(e);
    if (M && p.get(r)) return M == r;
    var x = !0;
    p.set(e, r), p.set(r, e);
    for (var Z = I; ++$ < D;) {
      N = w[$];
      var Y = e[N],
        te = r[N];
      if (l) var dt = I ? l(te, Y, N, r, e, p) : l(Y, te, N, e, r, p);
      if (!(dt === void 0 ? Y === te || _(Y, te, o, l, p) : dt)) {
        x = !1;
        break;
      }
      Z || (Z = N == "constructor");
    }
    if (x && !Z) {
      var ve = e.constructor,
        Se = r.constructor;
      ve != Se && "constructor" in e && "constructor" in r && !(typeof ve == "function" && ve instanceof ve && typeof Se == "function" && Se instanceof Se) && (x = !1);
    }
    return p.delete(e), p.delete(r), x;
  }
  function at(e) {
    return Gn(e, tr, Kn);
  }
  function Te(e, r) {
    var o = e.__data__;
    return qn(r) ? o[typeof r == "string" ? "string" : "hash"] : o.map;
  }
  function se(e, r) {
    var o = kt(e, r);
    return zn(o) ? o : void 0;
  }
  function Yn(e) {
    var r = z.call(e, Q),
      o = e[Q];
    try {
      e[Q] = void 0;
      var l = !0;
    } catch (_unused5) {}
    var _ = Qe.call(e);
    return l && (r ? e[Q] = o : delete e[Q]), _;
  }
  var Kn = tt ? function (e) {
      return e == null ? [] : (e = Object(e), Jt(tt(e), function (r) {
        return et.call(e, r);
      }));
    } : nr,
    q = ue;
  (De && q(new De(new ArrayBuffer(1))) != he || ce && q(new ce()) != v || Ne && q(Ne.resolve()) != B || Le && q(new Le()) != re || Re && q(new Re()) != oe) && (q = function q(e) {
    var r = ue(e),
      o = r == j ? e.constructor : void 0,
      l = o ? ee(o) : "";
    if (l) switch (l) {
      case un:
        return he;
      case fn:
        return v;
      case dn:
        return B;
      case pn:
        return re;
      case gn:
        return oe;
    }
    return r;
  });
  function Jn(e, r) {
    var _r2;
    return r = (_r2 = r) !== null && _r2 !== void 0 ? _r2 : u, !!r && (typeof e == "number" || Yt.test(e)) && e > -1 && e % 1 == 0 && e < r;
  }
  function qn(e) {
    var r = typeof e;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
  }
  function Zn(e) {
    return !!We && We in e;
  }
  function Wn(e) {
    var r = e && e.constructor,
      o = typeof r == "function" && r.prototype || Ee;
    return e === o;
  }
  function Qn(e) {
    return Qe.call(e);
  }
  function ee(e) {
    if (e != null) {
      try {
        return Ze.call(e);
      } catch (_unused6) {}
      try {
        return e + "";
      } catch (_unused7) {}
    }
    return "";
  }
  function ot(e, r) {
    return e === r || e !== e && r !== r;
  }
  var Xn = rt( /* @__PURE__ */function () {
      return arguments;
    }()) ? rt : function (e) {
      return fe(e) && z.call(e, "callee") && !et.call(e, "callee");
    },
    _e = Array.isArray;
  function kn(e) {
    return e != null && lt(e.length) && !ct(e);
  }
  var Me = cn || rr;
  function er(e, r) {
    return it(e, r);
  }
  function ct(e) {
    if (!ut(e)) return !1;
    var r = ue(e);
    return r == O || r == C || r == f || r == ae;
  }
  function lt(e) {
    return typeof e == "number" && e > -1 && e % 1 == 0 && e <= u;
  }
  function ut(e) {
    var r = typeof e;
    return e != null && (r == "object" || r == "function");
  }
  function fe(e) {
    return e != null && typeof e == "object";
  }
  var ft = qe ? Qt(qe) : Fn;
  function tr(e) {
    return kn(e) ? $n(e) : Pn(e);
  }
  function nr() {
    return [];
  }
  function rr() {
    return !1;
  }
  t.exports = er;
})(Oe, Oe.exports);
var Nr = Oe.exports;
var Lr = /* @__PURE__ */Dr(Nr);
var m = /* @__PURE__ */function (t) {
    return t.FIELD_ID = "data-contentful-field-id", t.ENTRY_ID = "data-contentful-entry-id", t.ASSET_ID = "data-contentful-asset-id", t.LOCALE = "data-contentful-locale", t.SPACE = "data-contentful-space", t.ENVIRONMENT = "data-contentful-environment", t;
  }(m || {}),
  ne = /* @__PURE__ */function (t) {
    return t.MOUSE_MOVE = "MOUSE_MOVE", t.SCROLL_START = "SCROLL_START", t.SCROLL_END = "SCROLL_END", t.RESIZE_START = "RESIZE_START", t.RESIZE_END = "RESIZE_END", t.TAGGED_ELEMENTS = "TAGGED_ELEMENTS", t.INSPECTOR_MODE_CHANGED = "INSPECTOR_MODE_CHANGED", t;
  }(ne || {}),
  Dt = {
    0: 8203,
    1: 8204,
    2: 8205,
    3: 8290,
    4: 8291,
    5: 8288,
    6: 65279,
    7: 8289,
    8: 119155,
    9: 119156,
    a: 119157,
    b: 119158,
    c: 119159,
    d: 119160,
    e: 119161,
    f: 119162
  },
  Nt = {
    0: 8203,
    1: 8204,
    2: 8205,
    3: 65279
  };
new Array(4).fill(String.fromCodePoint(Nt[0])).join("");
Object.fromEntries(Object.entries(Nt).map(function (t) {
  return t.reverse();
}));
Object.fromEntries(Object.entries(Dt).map(function (t) {
  return t.reverse();
}));
var Rr = "".concat(Object.values(Dt).map(function (t) {
    return "\\u{".concat(t.toString(16), "}");
  }).join("")),
  Ur = new RegExp("[".concat(Rr, "]{4,}"), "gu");
var Mr = function Mr(t) {
  if (!t || t.nodeType !== Node.ELEMENT_NODE) return !1;
  var n = t;
  return !(!n.hasAttribute(m.FIELD_ID) || !n.hasAttribute(m.ENTRY_ID) && !n.hasAttribute(m.ASSET_ID));
};
function xr(t, n) {
  var _t$getAttribute, _t$getAttribute2, _t$getAttribute3;
  if (!Mr(t)) return null;
  var i = {
      fieldId: t.getAttribute(m.FIELD_ID),
      locale: (_t$getAttribute = t.getAttribute(m.LOCALE)) !== null && _t$getAttribute !== void 0 ? _t$getAttribute : n.locale,
      environment: (_t$getAttribute2 = t.getAttribute(m.ENVIRONMENT)) !== null && _t$getAttribute2 !== void 0 ? _t$getAttribute2 : n.environment,
      space: (_t$getAttribute3 = t.getAttribute(m.SPACE)) !== null && _t$getAttribute3 !== void 0 ? _t$getAttribute3 : n.space,
      manuallyTagged: !0
    },
    a = t.getAttribute(m.ENTRY_ID);
  if (a) return _objectSpread(_objectSpread({}, i), {}, {
    entryId: a
  });
  var s = t.getAttribute(m.ASSET_ID);
  return s ? _objectSpread(_objectSpread({}, i), {}, {
    assetId: s
  }) : null;
}
function Lt(t, n) {
  return t.href === n.href;
}
function jr(t, n) {
  return !(!Lt(t.sourceMap, n.sourceMap) || t.element !== n.element);
}
function Rt(t, n) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  if (i === 0) return null;
  var a = t.parentElement;
  if (a) {
    var s = {
      sameInformation: 0,
      tagged: 0,
      all: 0
    };
    var c = t.nextElementSibling;
    for (; c;) {
      var d = vt(c.textContent || "");
      d && (s.tagged += 1, d.href === n.href && (s.sameInformation = 1)), s.all += 1, c = c.nextElementSibling;
    }
    var u = Rt(a, n, i - 1);
    if (u && u.counters.sameInformation >= 1) return u;
    if (s.sameInformation >= 1) return {
      element: a,
      counters: s
    };
  }
  return null;
}
function $r(t) {
  var n = [];
  return typeof t.matches == "function" && t.matches("*") && (n = [t]), [].concat(_toConsumableArray(n), _toConsumableArray(Array.from(t.querySelectorAll("*:not(script,style,meta,title)")))).map(function (i) {
    return {
      node: i,
      text: Gr(i)
    };
  }).filter(function (_ref3) {
    var i = _ref3.text;
    return !!(i && i.match(Ur));
  });
}
function Gr(t) {
  return t.matches("input[type=submit], input[type=button], input[type=reset]") ? t.value : t.matches("img, video") ? t.alt : Array.from(t.childNodes).filter(function (n) {
    return n.nodeType === Node.TEXT_NODE && !!n.textContent;
  }).map(function (n) {
    return n.textContent;
  }).join("");
}
function Br(t, n) {
  var _iterator2 = _createForOfIteratorHelper(n),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var i = _step2.value;
      if (i.element === t || i.element.contains(t)) return !0;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return !1;
}
function Fe(_ref4) {
  var _ref4$root = _ref4.root,
    t = _ref4$root === void 0 ? window.document : _ref4$root,
    n = _ref4.options,
    i = _ref4.ignoreManual;
  var s = _toConsumableArray(i ? [] : t.querySelectorAll("[".concat(m.ASSET_ID, "][").concat(m.FIELD_ID, "], [").concat(m.ENTRY_ID, "][").concat(m.FIELD_ID, "]"))).map(function (f) {
      return {
        element: f,
        attributes: xr(f, n)
      };
    }).filter(function (_ref5) {
      var f = _ref5.attributes;
      return f !== null;
    }),
    c = [],
    u = $r("body" in t ? t.body : t);
  var _iterator3 = _createForOfIteratorHelper(u),
    _step3;
  try {
    var _loop2 = function _loop2() {
        var _step3$value = _step3.value,
          f = _step3$value.node,
          h = _step3$value.text;
        var y = vt(h);
        if (!y || !y.origin.includes("contentful.com") || Br(f, s) || c.some(function (O) {
          return O.element.contains(f) && Lt(O.sourceMap, y);
        })) return 0; // continue
        if (f.matches("img")) {
          var O = f.closest("figure") || f.closest("picture") || f;
          c.push({
            element: O,
            sourceMap: y
          });
          return 0; // continue
        }
        var A = Rt(f, y);
        A ? c.push({
          element: A.element,
          sourceMap: y
        }) : c.push({
          element: f,
          sourceMap: y
        });
      },
      _ret2;
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      _ret2 = _loop2();
      if (_ret2 === 0) continue;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  var d = c.filter(function (f, h) {
    return c.findIndex(function (y) {
      return jr(f, y);
    }) === h;
  });
  var _iterator4 = _createForOfIteratorHelper(d),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _step4$value = _step4.value,
        f = _step4$value.element,
        h = _step4$value.sourceMap;
      if (!h.contentful) {
        W.warn("Element has missing information in their ContentSourceMap, please check if you have restricted the platform for the encoding. (Missing parameter: `contentful`)", {
          element: f,
          sourceMap: h
        });
        continue;
      }
      var y = {
        fieldId: h.contentful.field,
        locale: h.contentful.locale,
        space: h.contentful.space,
        environment: h.contentful.environment
      };
      h.contentful.entityType === "Asset" ? y.assetId = h.contentful.entity : h.contentful.entityType === "Entry" && (y.entryId = h.contentful.entity), s.push({
        element: f,
        attributes: y
      });
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  var E = s.filter(function (_ref6) {
    var f = _ref6.attributes;
    return (f == null ? void 0 : f.manuallyTagged) === !1 || !(f != null && f.manuallyTagged);
  }).length;
  return {
    taggedElements: s,
    manuallyTaggedCount: s.length - E,
    automaticallyTaggedCount: E,
    autoTaggedElements: d
  };
}
function Ut(_ref7) {
  var t = _ref7.options;
  return _toConsumableArray(new Set(Fe({
    options: t
  }).taggedElements.map(function (n) {
    return n.attributes && "entryId" in n.attributes ? n.attributes.entryId : null;
  }).filter(Boolean)));
}
var zr = /*#__PURE__*/_createClass(function zr(n) {
  var _this2 = this;
  _classCallCheck(this, zr);
  g(this, "delay", 300);
  g(this, "isScrolling", !1);
  g(this, "scrollTimeout");
  g(this, "isResizing", !1);
  g(this, "resizeTimeout");
  g(this, "hoveredElement");
  g(this, "taggedElements", []);
  g(this, "manuallyTaggedCount", 0);
  g(this, "automaticallyTaggedCount", 0);
  g(this, "intersectionObserver");
  g(this, "observersCB", []);
  g(this, "cleanupCB", []);
  /**
   * Attaches the event listeners and send the tagged elements once
   */
  g(this, "init", function () {
    _this2.cleanupCB = [_this2.addScrollListener(), _this2.addMutationListener(document.body), _this2.addResizeListener(), _this2.addHoverListener()], _this2.updateElements();
  });
  /**
   * Cancels all listeners and observers
   */
  g(this, "cleanup", function () {
    _this2.observersCB.forEach(function (n) {
      return n();
    }), _this2.cleanupCB.forEach(function (n) {
      return n();
    });
  });
  // Handles incoming messages from Contentful
  g(this, "receiveMessage", function (n) {
    if (n.method === ne.INSPECTOR_MODE_CHANGED) {
      var i = n.isInspectorActive;
      i ? _this2.init() : _this2.cleanup();
    }
  });
  /** Listen for changes on the element via intersection and mutation observer */
  g(this, "observe", function (n) {
    _this2.intersectionObserver.observe(n);
    var i = _this2.addMutationListener(n);
    _this2.observersCB.push(i, function () {
      return _this2.intersectionObserver.unobserve(n);
    });
  });
  /** Sends scroll start and end event to the editor, on end it also sends the tagged elements again */
  g(this, "addScrollListener", function () {
    var n = _this2.options.targetOrigin,
      i = function i() {
        _this2.isScrolling || (_this2.isScrolling = !0, F(ne.SCROLL_START, {}, n)), _this2.scrollTimeout && clearTimeout(_this2.scrollTimeout), _this2.scrollTimeout = setTimeout(function () {
          _this2.isScrolling = !1, F(ne.SCROLL_END, {}, n), _this2.updateElements();
        }, _this2.delay);
      },
      a = {
        capture: !0,
        passive: !0
      };
    return window.addEventListener("scroll", i, a), function () {
      return window.removeEventListener("scroll", i, a);
    };
  });
  /** Detects DOM changes and sends the tagged elements to the editor */
  g(this, "addMutationListener", function (n) {
    var i = new MutationObserver(function () {
      _this2.updateElements();
    });
    return i.observe(n, {
      // Content source maps
      characterData: !0,
      // Manual tagging
      attributes: !0,
      attributeFilter: [m.ENTRY_ID, m.FIELD_ID, m.LOCALE, m.SPACE, m.ENVIRONMENT, "class", "style"],
      // Adding or removal of new nodes
      childList: !0,
      // Include children
      subtree: !0
    }), function () {
      return i.disconnect();
    };
  });
  /** Sends resize start and end event to the editor, on end it also sends the tagged elements again */
  g(this, "addResizeListener", function () {
    var n = _this2.options.targetOrigin,
      i = new ResizeObserver(function () {
        _this2.isResizing || (_this2.isResizing = !0, F(ne.RESIZE_START, {}, n)), _this2.resizeTimeout && clearTimeout(_this2.resizeTimeout), _this2.resizeTimeout = setTimeout(function () {
          _this2.isResizing = !1, F(ne.RESIZE_END, {}, n), _this2.updateElements();
        }, _this2.delay);
      });
    return i.observe(document.body), function () {
      return i.disconnect();
    };
  });
  /** Checks if the hovered element is an tagged entry and then sends it to the editor */
  g(this, "addHoverListener", function () {
    var n = Ar(function (a) {
        var s;
        var _iterator5 = _createForOfIteratorHelper(a),
          _step5;
        try {
          var _loop3 = function _loop3() {
              var c = _step5.value;
              var u = c;
              if (u.nodeName === "BODY") return 0; // break
              var d = _this2.taggedElements.find(function (E) {
                return E.element === u;
              });
              if (d) {
                s = d;
                return 0; // break
              }
            },
            _ret3;
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            _ret3 = _loop3();
            if (_ret3 === 0) break;
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        _this2.hoveredElement = s == null ? void 0 : s.element, _this2.updateElements();
      }, _this2.delay),
      i = function i(a) {
        n(a.composedPath());
      };
    return window.addEventListener("mouseover", i, {
      passive: !0
    }), function () {
      return window.removeEventListener("mouseover", i);
    };
  });
  g(this, "sendTaggedElements", function () {
    F(ne.TAGGED_ELEMENTS, {
      elements: _this2.taggedElements.map(function (n) {
        return {
          // Important: do not add `element` as it can't be cloned by sendMessage
          coordinates: n.coordinates,
          isVisible: n.isVisible,
          attributes: n.attributes,
          isHovered: _this2.hoveredElement === n.element
        };
      }),
      automaticallyTaggedCount: _this2.automaticallyTaggedCount,
      manuallyTaggedCount: _this2.manuallyTaggedCount
    }, _this2.options.targetOrigin);
  });
  /**
   * Finds all elements that have all inspector mode attributes
   * and sends them to the editor
   */
  g(this, "updateElements", function () {
    var _Fe = Fe({
        options: _this2.options
      }),
      n = _Fe.taggedElements,
      i = _Fe.manuallyTaggedCount,
      a = _Fe.automaticallyTaggedCount,
      s = n.map(function (_ref8) {
        var c = _ref8.element,
          u = _ref8.attributes;
        return {
          element: c,
          coordinates: c.getBoundingClientRect(),
          attributes: u,
          isVisible: c.checkVisibility({
            checkOpacity: !0,
            checkVisibilityCSS: !0
          })
        };
      });
    Lr(s, _this2.taggedElements) || (_this2.observersCB.forEach(function (c) {
      return c();
    }), _this2.observersCB = [], _this2.taggedElements = s, n.forEach(function (_ref9) {
      var c = _ref9.element;
      return _this2.observe(c);
    }), _this2.manuallyTaggedCount = i, _this2.automaticallyTaggedCount = a);
  });
  this.options = n, this.intersectionObserver = new IntersectionObserver(function (i) {
    var a = _this2.taggedElements;
    var _iterator6 = _createForOfIteratorHelper(i),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var s = _step6.value;
        if (s.isIntersecting) {
          var _iterator7 = _createForOfIteratorHelper(a),
            _step7;
          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var c = _step7.value;
              c.element === s.target && (c.coordinates = s.intersectionRect, c.isVisible = s.target.checkVisibility({
                checkOpacity: !0,
                checkVisibilityCSS: !0
              }));
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
        }
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
    _this2.taggedElements = a, _this2.sendTaggedElements();
  }, {
    threshold: 0.15
  });
});
var ei = JSON.parse,
  Fr = JSON.stringify,
  Pr = String,
  Hr = "string",
  Et = "object",
  Vr = function Vr(t, n) {
    return n;
  },
  yt = function yt(t, n, i) {
    var a = Pr(n.push(i) - 1);
    return t.set(i, a), a;
  },
  Yr = function Yr(t, n, i) {
    var a = n && typeof n === Et ? function (h, y) {
        return h === "" || -1 < n.indexOf(h) ? y : void 0;
      } : n || Vr,
      s = /* @__PURE__ */new Map(),
      c = [],
      u = [];
    var d = +yt(s, c, a.call({
        "": t
      }, "", t)),
      E = !d;
    for (; d < c.length;) E = !0, u[d] = Fr(c[d++], f, i);
    return "[" + u.join(",") + "]";
    function f(h, y) {
      if (E) return E = !E, y;
      var A = a.call(this, h, y);
      switch (typeof A) {
        case Et:
          if (A === null) return A;
        case Hr:
          return s.get(A) || yt(s, c, A);
      }
      return A;
    }
  };
var P = /* @__PURE__ */function (t) {
  return t.CONNECTED = "CONNECTED", t.DISCONNECTED = "DISCONNECTED", t.ERROR = "ERROR", t.TAGGED_FIELD_CLICKED = "TAGGED_FIELD_CLICKED", t.URL_CHANGED = "URL_CHANGED", t.SUBSCRIBED = "SUBSCRIBED", t.UNSUBSCRIBED = "UNSUBSCRIBED", t.ENTRY_UPDATED = "ENTRY_UPDATED", t.ENTRY_SAVED = "ENTRY_SAVED", t.DEBUG_MODE_ENABLED = "DEBUG_MODE_ENABLED", t;
}(P || {});
function Kr(t, n) {
  F("TAGGED_FIELD_CLICKED", _objectSpread({
    action: "TAGGED_FIELD_CLICKED"
  }, t), n);
}
function Jr(t, n) {
  F("TAGGED_FIELD_CLICKED", _objectSpread({
    action: "TAGGED_FIELD_CLICKED"
  }, t), n);
}
var qr = /*#__PURE__*/function () {
  function qr(_ref10) {
    var n = _ref10.locale,
      i = _ref10.targetOrigin;
    _classCallCheck(this, qr);
    g(this, "subscriptions", /* @__PURE__ */new Map());
    g(this, "defaultLocale");
    g(this, "sendMessage");
    this.defaultLocale = n, this.sendMessage = function (a, s) {
      return F(a, s, i);
    };
  }
  /** Receives the data from the message event handler and calls the subscriptions */
  return _createClass(qr, [{
    key: "receiveMessage",
    value: (function () {
      var _receiveMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(n) {
        var i, a, s;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (n.method === P.ENTRY_UPDATED) {
                i = n.data, a = n.subscriptionId, s = this.subscriptions.get(a);
                s ? (s.callback(i), s.data = i, this.subscriptions.set(a, s)) : W.error("Received an update for an unknown subscription", {
                  subscriptionId: a,
                  data: i,
                  subscriptions: this.subscriptions
                });
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function receiveMessage(_x) {
        return _receiveMessage.apply(this, arguments);
      }
      return receiveMessage;
    }()
    /**
     * Subscribe to data changes from the Editor, returns a function to unsubscribe
     * Will be called once initially for the restored data
     */
    )
  }, {
    key: "subscribe",
    value: function subscribe(n) {
      var _n$locale,
        _this3 = this;
      var i = Cr(),
        a = (_n$locale = n.locale) !== null && _n$locale !== void 0 ? _n$locale : this.defaultLocale;
      this.subscriptions.set(i, _objectSpread({}, n));
      var s = {
        locale: a,
        event: "edit",
        id: i,
        config: Yr(n)
      };
      return this.sendMessage(P.SUBSCRIBED, s), function () {
        _this3.sendMessage(P.UNSUBSCRIBED, s), _this3.subscriptions.delete(i);
      };
    }
  }]);
}();
var Zr = /*#__PURE__*/function () {
  function Zr(_ref11) {
    var n = _ref11.locale,
      i = _ref11.options;
    _classCallCheck(this, Zr);
    g(this, "locale");
    g(this, "options");
    g(this, "subscription");
    this.locale = n, this.options = i;
  }
  return _createClass(Zr, [{
    key: "subscribe",
    value: function subscribe(n) {
      var _this4 = this;
      return this.subscription && W.log("There is already a subscription for the save event, the existing one will be replaced."), this.subscription = n, function () {
        _this4.subscription = void 0;
      };
    }
  }, {
    key: "receiveMessage",
    value: function receiveMessage(n) {
      if (n.method === P.ENTRY_SAVED && this.subscription) {
        var i = n.entity;
        Ut({
          options: this.options
        }).includes(i.sys.id) && this.subscription(i);
      }
    }
  }]);
}();
var ti = Ct,
  mt = ["https://app.contentful.com", "https://app.eu.contentful.com", "http://localhost:3001"
  // for local debugging for Contentful engineers
  ],
  R = /*#__PURE__*/function () {
    function R() {
      _classCallCheck(this, R);
    }
    return _createClass(R, null, [{
      key: "init",
      value:
      // Static method to initialize the LivePreview SDK
      function init(n) {
        var _this5 = this;
        var f;
        if (typeof n != "object" || !(n != null && n.locale)) throw new Error("Init function have to be called with a locale configuration (for example: `ContentfulLivePreview.init({ locale: 'en-US'})`)");
        var i = n.debugMode,
          a = n.enableInspectorMode,
          s = n.enableLiveUpdates,
          c = n.locale,
          u = n.environment,
          d = n.space,
          E = n.targetOrigin;
        if (typeof window < "u") {
          if (!Or()) return this.liveUpdatesEnabled = !1, Promise.resolve(null);
          if (i && ht(i), typeof a == "boolean" && (this.inspectorModeEnabled = a), typeof s == "boolean" && (this.liveUpdatesEnabled = s), this.locale = c, this.space = d, this.environment = u, this.initTargetOrigin(E), this.initialized) return W.log("You have already initialized the Live Preview SDK."), Promise.resolve(R.inspectorMode);
          this.inspectorModeEnabled && (this.inspectorMode = new zr({
            locale: c,
            space: d,
            environment: u,
            targetOrigin: this.targetOrigin,
            ignoreManuallyTaggedElements: (f = n.experimental) == null ? void 0 : f.ignoreManuallyTaggedElements
          })), this.liveUpdatesEnabled && (this.liveUpdates = new qr({
            locale: c,
            targetOrigin: this.targetOrigin
          }), this.saveEvent = new Zr({
            locale: c,
            options: {
              locale: this.locale,
              space: this.space,
              environment: this.environment,
              targetOrigin: this.targetOrigin
            }
          })), window.addEventListener("message", function (C) {
            var v, L, G;
            if (wr(C)) {
              if (W.log("Received message", C.data), C.data.method === P.DEBUG_MODE_ENABLED) {
                ht(!0);
                return;
              }
              _this5.inspectorModeEnabled && ((v = _this5.inspectorMode) == null || v.receiveMessage(C.data)), _this5.liveUpdatesEnabled && ((L = _this5.liveUpdates) == null || L.receiveMessage(C.data), (G = _this5.saveEvent) == null || G.receiveMessage(C.data));
            }
          }), vr(function () {
            F(P.URL_CHANGED, {
              action: P.URL_CHANGED,
              taggedElementCount: document.querySelectorAll("[".concat(m.ENTRY_ID, "]")).length
            }, _this5.targetOrigin);
          });
          var _ref12 = this.inspectorModeEnabled ? Fe({
              options: {
                locale: this.locale,
                space: this.space,
                environment: this.environment
              }
            }) : {
              taggedElements: [],
              manuallyTaggedCount: 0,
              automaticallyTaggedCount: 0
            },
            h = _ref12.taggedElements,
            y = _ref12.manuallyTaggedCount,
            A = _ref12.automaticallyTaggedCount,
            O = h.length;
          return F(P.CONNECTED, {
            action: P.CONNECTED,
            connected: !0,
            tags: O,
            taggedElementCount: O,
            locale: this.locale,
            isInspectorEnabled: this.inspectorModeEnabled,
            isLiveUpdatesEnabled: this.liveUpdatesEnabled,
            manuallyTaggedElementCount: y,
            automaticallyTaggedElementCount: A
          }, this.targetOrigin), this.initialized = !0, Promise.resolve(R.inspectorMode);
        }
      }
    }, {
      key: "initTargetOrigin",
      value: function initTargetOrigin(n) {
        if (n) this.targetOrigin = Array.isArray(n) ? n : [n];else {
          var i = window.location.ancestorOrigins,
            a = i ? mt.find(function (s) {
              return i.contains(s);
            }) :
            //less consistent workaround for Firefox, where ancestorOrigins is not supported
            mt.find(function (s) {
              return document.referrer.includes(s);
            });
          if (!a) throw new Error("The current origin is not supported. Please provide a targetOrigin in the live preview configuration.");
          this.targetOrigin = [a];
        }
      }
    }, {
      key: "subscribe",
      value: function subscribe(n, i) {
        if (!this.liveUpdatesEnabled) return function () {};
        var a = typeof n == "string" ? n : "edit",
          s = typeof n == "object" ? n : i;
        if (a === "save") {
          if (!this.saveEvent) throw new Error("Save event is not initialized, please call `ContentfulLivePreview.init()` first.");
          return this.saveEvent.subscribe(s.callback);
        }
        if (!this.liveUpdates) throw new Error("Live updates are not initialized, please call `ContentfulLivePreview.init()` first.");
        return this.liveUpdates.subscribe(s);
      }
      // Static method to render live preview data-attributes to HTML element output
    }, {
      key: "getProps",
      value: function getProps(n) {
        var i = n.fieldId,
          a = n.locale,
          s = n.environment,
          c = n.space;
        if (!this.inspectorModeEnabled) return null;
        if (i) {
          var u = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, a ? _defineProperty({}, m.LOCALE, a) : {}), s ? _defineProperty({}, m.ENVIRONMENT, s) : {}), c ? _defineProperty({}, m.SPACE, c) : {}), {}, _defineProperty({}, m.FIELD_ID, i));
          if (a && (u[m.LOCALE] = a), n.assetId !== void 0) return _objectSpread(_objectSpread({}, u), {}, _defineProperty({}, m.ASSET_ID, n.assetId));
          if (n.entryId !== void 0) return _objectSpread(_objectSpread({}, u), {}, _defineProperty({}, m.ENTRY_ID, n.entryId));
        }
        return W.warn("Missing property for inspector mode", _objectSpread({}, n)), null;
      }
    }, {
      key: "toggleInspectorMode",
      value: function toggleInspectorMode() {
        return this.inspectorModeEnabled = !this.inspectorModeEnabled, this.inspectorModeEnabled;
      }
    }, {
      key: "toggleLiveUpdatesMode",
      value: function toggleLiveUpdatesMode() {
        return this.liveUpdatesEnabled = !this.liveUpdatesEnabled, this.liveUpdatesEnabled;
      }
    }, {
      key: "openEntryInEditor",
      value: function openEntryInEditor(n) {
        var i = {
          locale: this.locale,
          environment: this.environment,
          space: this.space
        };
        if (n.assetId !== void 0 && n.fieldId) {
          Jr(_objectSpread(_objectSpread({}, i), n), this.targetOrigin);
          return;
        }
        if (n.entryId !== void 0 && n.fieldId) {
          Kr(_objectSpread(_objectSpread({}, i), n), this.targetOrigin);
          return;
        }
        W.error("Please provide field id and entry id to openEntryInEditor.");
      }
      /**
       * Returns a list of tagged entries on the page
       */
    }, {
      key: "getEntryList",
      value: function getEntryList() {
        return Ut({
          options: {
            locale: this.locale,
            space: this.space,
            environment: this.environment
          }
        });
      }
    }]);
  }();
g(R, "initialized", !1), g(R, "inspectorMode", null), g(R, "liveUpdates", null), g(R, "saveEvent", null), g(R, "inspectorModeEnabled", !0), g(R, "liveUpdatesEnabled", !0), g(R, "locale"), g(R, "space"), g(R, "environment"), g(R, "sendMessage"), g(R, "targetOrigin");
var bt = R;
export { bt as C, ne as I, Sr as L, ti as V, Xr as a, Qr as b, Ir as c, Ar as d, P as e, Jr as f, Lr as i, Kr as o, kr as u };